// extracted by mini-css-extract-plugin
export var terminal = "terminal-window-module--terminal--1_4-4";